function Journalist(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">보도</h4>
                <h5 className="recruit_titleline_title">취재기자</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    방송 기자는 현장의 최전선에서 취재하고 이를 방송 기사로 제작합니다.<br />
                    디지털 혁신의 일환으로, 최적의 디지털 콘텐츠를 만들기도 합니다. <br />
                    취재한 내용 중 뉴스 가치가 있는 정보만 벼를 수 있는 판단력과 돌발 상황에 대처할 수 있는 순발력이 필요합니다. 또 기자 개인이 취재 아이템 선정부터 기사 작성, 제작 과정 전반을 주도하기 때문에 매 순간 취재윤리에 기반한 올바른 선택을 할 수 있어야 합니다.<br />
                    취재원 관리와 협업도 중요한 만큼 사람에 대한 깊은 관심도 필요하고 끈기, 체력도 중요합니다.<br />
                    SBS 현직 기자들의 개성과 강점도 저마다 뚜렷한데요, 획일화된 기준에 자신을 맞추려 하기 보다 고유한 강점을 200% 살려보는 게 더 유리할 수 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    보도 본부는 크게 보도국, 디지털뉴스국, 스포츠국으로 나뉩니다. <br />
                    보도국의 정치, 경제, 사회, 문화, 탐사 등 취재 부서에선 여러 분야를 깊이 있게 살펴볼 기회가 주어지는데요,<br />
                    권력을 감시·비판하고 세상 곳곳에서 일어나는 사건·사고, 소식에 주목합니다.
                    뉴스의 현장을 지키며 우리 사회가 한 걸음 더 나아갈 방법을<br /> 치열하게 고민하죠.
                    8뉴스부, 일반뉴스부 등에서 뉴스 프로그램 기획 및 제작 업무를 맡을 수도 있습니다.<br /> 선거 등 중요 행사가 있는 경우, 별도로 TF팀에 파견돼 색다른 경험을 쌓을 수 있습니다.<br />
                    디지털뉴스국에선 뉴스 콘텐츠의 유통, 사업 전략을 구상할 뿐만 아니라 미디어 환경변화에 맞춰 콘텐츠를 기획, 제작합니다. <br />
                    각 분야 디지털 전문 인력들과 함께 다양한 시도를 하며 시장을 선도하고 있는데요, 특히 비디오머그, 취재파일 등 버티컬 브랜드를 출시해<br />
                    독자들과 접점을 확대하고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    다양한 분야에서 활약하는 선배들은 주니어 기자들의 커리어패스, 그 자체입니다.<br />
                    국제 정세에 관심이 있다면 그 분야 취재 경험을 쌓고 워싱턴, 베이징, 파리 등 전 세계 현장을 누비는 특파원이 될 수 있고요. <br />
                    전문기자 육성 제도를 활용해 내 관심 분야를 심층 취재할 기회를 거머쥘 수도 있습니다.<br />
                    방송 기자로서 출연, 진행 능력을 인정받아 유능한 앵커로 거듭날 수도 있고, 데이터 저널리즘, 디지털 혁신 분야 등 미디어 환경 변화에 빠르게 적응하며 자신만의 길을 개척할 수도 있습니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    안녕하세요, 저는 보도본부 시민사회팀에서 일하고 있는 신정은입니다. <br />
                    2017년 입사한 후 뉴미디어뉴스부(현 디지털플랫폼부), 시민사회팀을 거쳤습니다. 틱톡 등 SNS 플랫폼에선 뉴스를 쉽고 친절하게 전달하는<br />
                    &#39;뉴스테이너&#39;로도 활약하고 있어요.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">기자가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    기자가 된다면 제가 좋아하는 방송, 뉴스 산업 분야에 종사하면서 더 나은 세상을 만드는 데 힘을 보탤 수 있다고 생각했습니다. <br />
                    어린 시절부터 막연하게 방송국이나 미디어 업계에서 일하고 싶었는데, 학창시절 다양한 경험을 쌓으며 &#39;기자&#39;라는 직업으로 구체화됐죠. <br />
                    기자가 되고 나니 제가 생각했던 것보다 훨씬 다양한 현장에서 두루 경험을 쌓을 수 있었습니다. 매일 새로운 일들이 눈앞에 펼쳐지기에 지루할 틈도 없죠.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    뉴스가 필요한 현장을 지킬 때 가장 큰 보람을 느낍니다. 저마다 억울한 사연을 지닌 제보자들을 만나거나, 사건·사고, 재난재해 현장 등 <br />
                    세상의 관심이 필요한 곳을 찾아 제 몫의 일을 했을 때 보람차요. 같은 현장이라도 기자 나름입니다. 한 발 더 뛰고, 한 사람이라도 더 만났을 때<br />
                    상황을 더 잘 반영할 수 있고, 기사에 진심이 담기죠. 또 제가 쓴 기사가 제도 변화를 이끌어 내거나 사회적 반향을 일으켰을 때도 뿌듯합니다.<br />
                    이 일을 하다 우연히 친해진 8살 아이가 저를  &#39;롤-모델&#39;로 꼽고 반 친구들에게 소개했다는데, 어찌나 큰 힘이 되던지. 더 좋은 기자가<br />
                    되어야겠다고 다짐한 계기가 됐습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    언론사 입사를 준비하며 채용 홈페이지를 들락거렸던 게 엊그제 같은데 벌써 중연차 기자로 거듭나고 있습니다.
                    돌이켜보면 언제, 어디서나<br /> 하고 싶은 취재를 원 없이 할 수 있었던 것 같아요.
                    또 현업에서 다양한 디지털 혁신을 시도할 기회가 주어져 다른 어느 곳에서보다 빠르게<br /> 성장하며 역량을 키울 수 있었다고 자신합니다.
                    업무 특성상 때로 지치거나 버거울 때도 있지만 좋은 동료들이 든든한 버팀목이 되어줍니다.<br />
                    SBS는 당신의 꿈을 펼칠 수 있는 무대가 될 겁니다. 하루빨리 현장에서 만나 함께 일하길 고대하겠습니다.
                </p>
            </div>
        </div>
    );
}

export default Journalist;

